<template>
  <div class="Body-wrapper">
<!--     <Loader
      :hidden="true"
      :url="'/'"
      v-model="status"
    >
      <div slot="result">
        {{ JSON.stringify (status) }}
      </div>
    </Loader> -->

    <!-- <AccountBar></AccountBar> -->

    <Navbar></Navbar>

    <main class="Body-main">
      <router-view />
    </main>

    <Footer></Footer>
  </div>
</template>

<script>
  import AccountBar from '@/legacy/views/section/AccountBar';
  import Navbar from '@/legacy/views/section/Navbar';
  import Footer from '@/legacy/views/section/Footer';
  import Loader from '@/legacy/components/widgets/Loader';

  export default {
    metaInfo () {
      let page = 'Index';
      let title = 'Warcraft III Stats';
      let description = 'View game and player statistics from a growing database of Warcraft III custom game replays. Extract APM, ratings, custom map meta-data and more!';
      let image = `${window.location.origin}/assets/favicon.png`;
      let icon = `${window.location.origin}/assets/favicon.ico`;
      let canonical = window.location.href;

      return {
        title: page,
        titleTemplate: `%s | ${title}`,

        meta: [
          { vmid: 'charset', charset: 'utf-8' },
          { vmid: 'robots', name: 'robots', content: 'index, follow' },
          { vmid: 'description', name: 'description', content: description },

          /* Open Graph */
          { vmid: 'og:type', property: 'og:type', content: 'website' },
          { vmid: 'og:title', property: 'og:title', content: page, template: `%s | ${title}` },
          { vmid: 'og:description', property: 'og:description', content: description },
          { vmid: 'og:image', property: 'og:image', content: image },
          { vmid: 'og:url', property: 'og:url', content: canonical },
          { vmid: 'og:site_name', property: 'og:site_name', content: 'Warcraft III Stats' },

          /* Twitter */
          { vmid: 'twitter:title', property: 'twitter:title', content: page, template: `%s | ${title}` },
          { vmid: 'twitter:description', property: 'twitter:description', content: description },
          { vmid: 'twitter:image', property: 'twitter:image', content: image }
        ],

        link: [
          { vmid: 'shortcut', rel: 'shortcut icon', href: icon },
          { vmid: 'apple-touch-icon', rel: 'apple-touch-icon image_src', href: icon },
          { vmid: 'canonical', rel: 'canonical', href: canonical }
        ]
      };
    },

    data () {
      return {
        status: null
      }
    },

    components: {
      AccountBar,
      Navbar,
      Footer,
      Loader
    }
  }
</script>

<style lang="scss">
  .Body {
    &-wrapper {
      height: 100%;
      min-height: 100%;
      width: 100%;
    }

    /** **/

    &-main {
      display: flex;
      flex-direction: column;
      min-height: 100%;
      width: 100%;

      background: rgba(var(--grey), 1) no-repeat;
      background-size: cover;
      background-repeat: no-repeat;

      /** **/

      > div {
        position: relative;
        z-index: fetch(z-index main);
        flex-grow: 1;
        padding-bottom: 40px;
        width: 100%;
        background-size: 100% auto;
        background-position: center 0;
      }
    }
  }
</style>
